import { UploadsService } from "@/stores/uploads";

export default async function profileUploadsLoader() {
  const uploads = await UploadsService.getUploads();
  return { uploads };
}
